import React from 'react';
import { Body, Box } from '@hover/blueprint';
import styled from '@emotion/styled';
import HeroLink from '../terms-of-use/HeroLink';

const StyledWrapper = styled(Box)`
  @media (max-width: 480px) {
    flex-direction: column;
    p:first-of-type {
      margin-bottom: 0.25rem;
    }
  }
`;

const HeroLinks: React.FC = () => (
  <StyledWrapper
    alignItems={{ base: 'flex-start', tablet: 'center' }}
    pt={100}
    pb={50}
  >
    <Body isSemiBold size={300}>
      Access previous HOVER Privacy Policy from &nbsp;
    </Body>
    <Body isSemiBold size={300} d="inline-block">
      <HeroLink body="May 1, 2022" to="/privacy-may-2022/" />
      &nbsp; / &nbsp;
      <HeroLink body="October 12, 2020" to="/privacy-oct-2020/" />
      &nbsp; / &nbsp;
      <HeroLink body="January 1, 2020" to="/privacy-jan-2020/" />
    </Body>
  </StyledWrapper>
);

export default HeroLinks;
